import {Events, Superstars, TagTeams} from "./models.js";

function Streak() {

    // Integer
    const length = 1;

    // Boolean
    const ended = false;

    // Foreign keys
    const superstarId = null;
    const tagTeamId = null;
    const eventId = null;

    return {
        length,
        ended,
        superstarId,
        tagTeamId,
        eventId,
    };
}

function getStreakSuperstar(streak) {
    return Superstars.find({'$loki': streak.superstarId})[0];
}

function getStreakTagTeam(streak) {
    return TagTeams.find({'$loki': streak.tagTeamId})[0];
}

function getStreakEvent(streak) {
    return Events.find({'$loki': streak.eventId})[0];
}

function getStreakTalent(streak) {
    if (streak.superstarId) {
        return getStreakSuperstar(streak)
    }
    else {
        return getStreakTagTeam(streak)
    }
}


export { Streak, getStreakEvent, getStreakSuperstar, getStreakTagTeam, getStreakTalent }
